import { useForm } from 'react-hook-form'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { OTP_REGEX } from 'src/utils/regex'
import { verifyOTPRequestInterface } from 'src/interfaces/address'
import { verifyOTP } from 'src/useCase/address'
import { useAppDispatch } from 'src/store'
import { useSearchParams } from 'react-router-dom'
import { trackStep, JOURNEY_STEP } from 'src/utils/tracker'

export const useSMSForm = (planType) => {
  const dispatch = useAppDispatch()
  const [searchParams] = useSearchParams()
  const menuId = searchParams.get('menu_id') ?? ''

  const defaultValues: verifyOTPRequestInterface = {
    otp: '',
  }

  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .required('入力してください。')
      .matches(OTP_REGEX, 'コードは半角数字6桁で入力してください'),
  })

  const onSubmit = async (data: verifyOTPRequestInterface) => {
    try {
      await dispatch(
        verifyOTP({
          credentials: data,
          meta: form,
          planType: planType,
          menu_id: menuId,
        }),
      ).unwrap()
      trackStep(JOURNEY_STEP.SMS_VERIFIED)
    } catch {
      // verifyOTP thunk handles error display; do not track on failure
    }
  }

  const form = useForm<verifyOTPRequestInterface>({
    defaultValues,
    shouldFocusError: true,
    mode: 'all',
    resolver: yupResolver(validationSchema),
  })

  return {
    form,
    onSubmit,
  }
}
